import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { Autocomplete, Chip, TextField } from '@mui/material';
import { usePartners } from '../../hooks/partners/usePartners';
import { Partner } from '../../types/partner';

type AutocompleteFieldProps = {
  controllerInitialState: UseControllerProps<any>;
  label: string;
};

export const PartnerSelectorField: React.FC<AutocompleteFieldProps> = ({ controllerInitialState, label }) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController(controllerInitialState);

  const { partners } = usePartners();

  return (
    <Autocomplete
      id={'roles-autoComplete-option-0'}
      multiple
      fullWidth
      onChange={(_, data) => onChange(data)}
      value={value}
      disablePortal
      getOptionLabel={option => option.name}
      options={partners.sort((a, b) => (a.name > b.name ? 1 : -1))}
      renderTags={(value: Partner[], getTagProps) =>
        value.map((option, index) => (
          // eslint-disable-next-line react/jsx-key
          <Chip variant="outlined" label={option.name} {...getTagProps({ index })} />
        ))
      }
      renderInput={params => (
        <TextField {...params} fullWidth label={label} error={!!error} helperText={error ? error.message : null} />
      )}
    />
  );
};
